module.exports =  [
  {
    text: 'Sujet',
    value: 'title',
    sortable: false,
    multiple: false,
    multipleName: '',
    pointer: false,
    affichage: true,
    inputVisible: true,
    pointerName: '',
    width: '10',
    align: 'right'
  },
  {
    text: 'Catégorie',
    value: 'category_subject',
    sortable: false,
    multiple: false,
    multipleName: '',
    pointer: true,
    affichage: true,
    inputVisible: true,
    pointerName: 'name',
    width: '10',
    align: 'right'
  },
  {
    text: 'Réponse',
    value: 'email',
    sortable: false,
    multiple: false,
    multipleName: '',
    pointer: false,
    affichage: true,
    inputVisible: true,
    pointerName: '',
    width: '10',
    align: 'right'
  },
  {
    text: 'Action',
    value: 'roles',
    sortable: false,
    multiple: true,
    multipleName: 'display_name',
    pointer: false,
    affichage: true,
    inputVisible: false,
    pointerName: '',
    width: '10',
    align: 'right'
  }
]